
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ProductModelMstApi } from '../../api/master/productmodel-mst.api';
import { ProductModelMst, ProductModelMstData } from '../../interface/master/productmodel-mst';

@Injectable()
export class ProductModelMstService extends ProductModelMstData {

  constructor(private api: ProductModelMstApi) {
    super();
  }
  list(url: string): Observable<ProductModelMst[]> {
    return this.api.list(url);
  }
  getById(url:string): Observable<ProductModelMst>{
      return this.api.getById(url);
  }
  create(url: string, data:ProductModelMst): Observable<ProductModelMst> {
    return this.api.add(url,data);
  }
  update(url: string, data:ProductModelMst): Observable<ProductModelMst> {
    return this.api.update(url,data);
  }
  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
